export default __webpack_public_path__ + "static/media/ic-avg-working-hrs.0b6fbca8.svg";